import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/iVertex_black.png";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Welcome!{" "}
              </h1>

              <h1 className="heading-name">
                iVertex your Partner in<br></br>
                Artificial Intelligence (AI)
                <br></br> Let us lead the way!
              </h1>

              <div style={{ padding: 50, textAlign: "left" }}>
                <Type />
              </div>
            </Col>

            <Col md={5} style={{ paddingLeft: 50, paddingTop: 100 }}>
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid"
                style={{ maxHeight: "250px", alignContent: "center" }}
              />
              <p></p>

              <h4>
                <i>
                  <p align="left">AI Consulting </p>
                </i>
              </h4>
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
    </section>
  );
}

export default Home;
